export const BlindsOpen = () => (
  <svg
    width="59"
    height="58"
    viewBox="0 0 59 58"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <filter
        x="-25%"
        y="-14.4%"
        width="150%"
        height="151.1%"
        filterUnits="objectBoundingBox"
        id="ksr8cixe4a"
      >
        <feOffset dy="5" in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur stdDeviation="3" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
        <feColorMatrix
          values="0 0 0 0 0.407843137 0 0 0 0 0.607843137 0 0 0 0 0.878431373 0 0 0 0.24 0"
          in="shadowBlurOuter1"
        />
      </filter>
      <rect id="2rbkdqgy3b" x="1.408" y="2" width="46" height="45" rx="16" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(5.5)">
        <use fill="#000" filter="url(#ksr8cixe4a)" xlinkHref="#2rbkdqgy3b" />
        <use fill="#FFF" xlinkHref="#2rbkdqgy3b" />
      </g>
      <g fill="#2396FD">
        <path d="m30.6 20.2 9.1 13.3H21.5zM21.5 16h18.2v4.2H21.5z" />
      </g>
    </g>
  </svg>
);
